import React from "react";
import SvgIcon from "../../Common/Component/SvgIcon";

/** Maps semantic names to IDs in public/svg/sprite.svg */
export const CREDORA_ICON_IDS = {
  search: "stroke-search",
  eye: "fill-sample-page",
  view: "fill-sample-page",
  edit: "pencil",
  pencil: "pencil",
  calendar: "stroke-calendar",
  calender: "stroke-calendar",
  filter: "stroke-ui-kits",
  export: "arrowright",
  check: "profile-check",
  user: "stroke-user",
  userFill: "fill-user",
  home: "stroke-home",
  file: "stroke-file",
  widget: "stroke-widget",
  grid: "stroke-widget",
  board: "stroke-board",
  project: "stroke-project",
  email: "stroke-email",
  notification: "notification",
  chat: "stroke-chat",
  ecommerce: "stroke-ecommerce",
  knowledgebase: "stroke-knowledgebase",
  contact: "stroke-contact",
  animation: "stroke-animation",
  charts: "fill-charts",
  chartsStroke: "stroke-charts",
  table: "stroke-table",
  list: "stroke-table",
  form: "stroke-form",
  settings: "stroke-form",
  faq: "stroke-faq",
  disbursement: "sale",
  bank_transfer: "profit",
  mobile_wallet: "customers",
  partner: "sale",
  cash_pickup: "expense",
  orders: "orders",
  cheque: "orders",
  profit: "profit",
  collection: "profit",
  wallet: "income",
  security: "stroke-board",
  rate: "rate",
  payment: "income",
  income: "income",
  mobile_money: "fill-contact",
  fill_chat: "fill-chat",
  application: "new-order",
  failed: "stroke-support-tickets",
  due: "clock",
  clock: "clock",
  pending: "clock",
  warning: "stroke-faq",
  star: "star",
  customers: "customers",
  expense: "expense",
  "support-tickets": "stroke-support-tickets",
  alert: "stroke-faq",
  attention: "fill-faq",
  minus: "stroke-user",
  plus: "new-order",
  users: "customers",
  role: "stroke-user",
  department: "stroke-project",
  branch: "stroke-board",
  status: "stroke-charts",
  clear: "bin",
  trash: "bin",
  prepayment: "stroke-calendar",
};

/** Sprite symbols that use filled paths (not stroke-* outlines). */
const FILL_SPRITE_IDS = new Set([
  "profit",
  "sale",
  "clock",
  "expense",
  "rate",
  "income",
  "customers",
  "star",
  "new-order",
  "pencil",
  "bin",
  "arrowright",
  "profile-check",
  "orders",
]);

/** Pick svg-fill vs svg-stroke from resolved sprite id. */
export function credoraIconClassName(iconId, override) {
  if (override) {
    return override;
  }
  if (!iconId) {
    return "svg-stroke";
  }
  if (iconId.startsWith("fill-") || FILL_SPRITE_IDS.has(iconId)) {
    return "svg-fill";
  }
  return "svg-stroke";
}

/** Resolve a semantic icon name to a sprite symbol id. */
export function resolveCredoraIconId(name) {
  if (!name) {
    return null;
  }
  if (CREDORA_ICON_IDS[name]) {
    return CREDORA_ICON_IDS[name];
  }
  if (name.startsWith("stroke-") || name.startsWith("fill-")) {
    return name;
  }
  return null;
}

/**
 * @param {object} props
 * @param {keyof typeof CREDORA_ICON_IDS | string} props.name — semantic name or raw sprite id
 * @param {number} [props.size=16]
 */
const CredoraIcon = ({ name, size = 16, className = "", iconClassName, ...rest }) => {
  const iconId = resolveCredoraIconId(name);
  if (!iconId) {
    return null;
  }
  const resolvedIconClassName = credoraIconClassName(iconId, iconClassName);
  return (
    <span className={`credora-icon ${className}`.trim()} aria-hidden={rest["aria-label"] ? undefined : true}>
      <SvgIcon iconId={iconId} width={size} height={size} className={resolvedIconClassName} {...rest} />
    </span>
  );
};

export default CredoraIcon;
